"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeMoveType = exports.HierarchyType = exports.NodeType = exports.NodeMoveState = void 0;
var NodeMoveState;
(function (NodeMoveState) {
    NodeMoveState[NodeMoveState["None"] = 0] = "None";
    NodeMoveState[NodeMoveState["Move"] = 1] = "Move";
    NodeMoveState[NodeMoveState["MoveBranch"] = 2] = "MoveBranch";
    NodeMoveState[NodeMoveState["MoveKeepOpen"] = 3] = "MoveKeepOpen";
})(NodeMoveState = exports.NodeMoveState || (exports.NodeMoveState = {}));
var NodeType;
(function (NodeType) {
    NodeType[NodeType["Person"] = 0] = "Person";
    NodeType[NodeType["Position"] = 1] = "Position";
    NodeType[NodeType["Location"] = 2] = "Location";
    NodeType[NodeType["BusinessUnit"] = 3] = "BusinessUnit";
})(NodeType = exports.NodeType || (exports.NodeType = {}));
var HierarchyType;
(function (HierarchyType) {
    HierarchyType[HierarchyType["Person"] = 0] = "Person";
    HierarchyType[HierarchyType["Position"] = 1] = "Position";
    HierarchyType[HierarchyType["NonManagerialNotSpecified"] = 2] = "NonManagerialNotSpecified";
    HierarchyType[HierarchyType["BusinessUnit"] = 3] = "BusinessUnit";
    HierarchyType[HierarchyType["Location"] = 4] = "Location";
    HierarchyType[HierarchyType["Function"] = 5] = "Function";
    HierarchyType[HierarchyType["Hybrid"] = 6] = "Hybrid";
    HierarchyType[HierarchyType["Other"] = 7] = "Other";
})(HierarchyType = exports.HierarchyType || (exports.HierarchyType = {}));
var NodeMoveType;
(function (NodeMoveType) {
    NodeMoveType[NodeMoveType["MoveNodeOverNode"] = 1] = "MoveNodeOverNode";
    NodeMoveType[NodeMoveType["MoveToUnparented"] = 2] = "MoveToUnparented";
    NodeMoveType[NodeMoveType["MoveNodeUnder"] = 3] = "MoveNodeUnder";
    NodeMoveType[NodeMoveType["MovePersonOverPersonNode"] = 4] = "MovePersonOverPersonNode";
    NodeMoveType[NodeMoveType["MovePersonToUnparented"] = 5] = "MovePersonToUnparented";
    NodeMoveType[NodeMoveType["MovePersonUnderPersonNode"] = 6] = "MovePersonUnderPersonNode";
    NodeMoveType[NodeMoveType["MoveLocationNode"] = 9] = "MoveLocationNode";
})(NodeMoveType = exports.NodeMoveType || (exports.NodeMoveType = {}));
